/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DataChartBarsXIcon16Light } from './DataChartBarsXIcon16Light';
import { DataChartBarsXIcon16Regular } from './DataChartBarsXIcon16Regular';
import { DataChartBarsXIcon16Solid } from './DataChartBarsXIcon16Solid';
import { DataChartBarsXIcon20Light } from './DataChartBarsXIcon20Light';
import { DataChartBarsXIcon20Regular } from './DataChartBarsXIcon20Regular';
import { DataChartBarsXIcon20Solid } from './DataChartBarsXIcon20Solid';
import { DataChartBarsXIcon24Regular } from './DataChartBarsXIcon24Regular';
import { DataChartBarsXIcon24Solid } from './DataChartBarsXIcon24Solid';
import { DataChartBarsXIcon32Regular } from './DataChartBarsXIcon32Regular';
import { DataChartBarsXIcon64Regular } from './DataChartBarsXIcon64Regular';
var sizes = {
    16: {
        light: DataChartBarsXIcon16Light,
        regular: DataChartBarsXIcon16Regular,
        solid: DataChartBarsXIcon16Solid,
    },
    20: {
        light: DataChartBarsXIcon20Light,
        regular: DataChartBarsXIcon20Regular,
        solid: DataChartBarsXIcon20Solid,
    },
    24: {
        regular: DataChartBarsXIcon24Regular,
        solid: DataChartBarsXIcon24Solid,
    },
    32: {
        regular: DataChartBarsXIcon32Regular,
    },
    64: {
        regular: DataChartBarsXIcon64Regular,
    },
};
export var DataChartBarsXIcon = forwardRef('DataChartBarsXIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
